"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PInterval = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var PBound_1 = require("./PBound.js");
exports.PInterval = (0, pstruct_1.pstruct)({
    PInterval: {
        from: PBound_1.PBound.type,
        to: PBound_1.PBound.type
    }
});
